export default __webpack_public_path__ + "static/media/ohLogo.19c380de.svg";